<template>
  <div class="versionRecord">
    <div class="top">
      <div class="title">
        <span>版本记录</span>
        <span @click="$emit('changeShow')"><i class="iconfont iconcebianshouqi"></i></span>
      </div>
    </div>
    <div class="content">
      <div class="versionItem" v-for="(item,index) in versionData" :key="index">
        <div class="versionNum" @click="changeStatus(item,index)">
          <span class="dian"></span>
          <div class="versionTitle">
            <span>{{ item.versionNo }}</span>
            <i class="iconfont iconshouqi" v-if="item.show"></i>
            <i class="iconfont iconzhankai" v-else></i>
          </div>
          
        </div>
        <div class="versionContent">
          <div class="versionContentHtml" v-if="item.show">
            <div>
              <span>发版时间：</span>
              <span>{{ item.releaseTime | filterTime('YYYY-MM-DD') }}</span>
            </div>
            <div>
              <div>发版内容：</div>
              <span v-html="item.content"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="versionItem" v-if="!versionData || versionData.length<=0">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      versionData:{}
    }
  },
  mounted(){
    this.getVersionList()
  },
  methods:{
    changeStatus(item){
      this.$set(item,'show',!item.show)
      this.$forceUpdate()
    },
    //查询版本数据
   getVersionList() {
      this.$http({
        url: "/buz/content/versionRecords/page",
        type: "post",
        data: {
          pageSize:30,
          pageNo:1,
          platformType:2
        }
      }).then(res => {
        this.versionData = res.data
        this.versionData.forEach((item,index)=>{
          if(index == '0'){
            item.show = true
          }else{
            item.show = false
          }
        })
      });
    },
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar-track{
  background-color:transparent;
  border-radius: 4px;
}
::-webkit-scrollbar{
  width: 4px;
}
::-webkit-scrollbar-thumb {
    background-color: rgba(255,255,255,0.39);
}
::-webkit-scrollbar-corner {
  background: rgba(0,0,0,0);
}
.iconfont{
  cursor: pointer;
}
/deep/ {
  table{
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    th{
      border-bottom: 2px solid #ccc;
      text-align: center;
      background-color: #f1f1f1;
    }
    td{
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      padding: 3px 5px;
      min-height: 30px;
    }
  }
}
.versionRecord{
  position: absolute;
  left: 50px;
  top: 10vh;
  width: 600px;
  height: 81vh;
  background: rgba(0,48,142,0.7);
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  padding: 20px;
  border-radius: 8px;
  .iconzhankai,.iconshouqi{
    width: 12px;
    height: 7px;
  }
  .title{
    display: flex;
    justify-content: space-between;
    margin-bottom: 17px;
  }
  
  .content{
    width: 550px;
    height: 73vh;
    overflow: auto;
    .versionItem{
      &:last-child{
        .versionContent{
          border-left:0;
        }
      }
      
      .versionNum{
        font-size: 16px;
        font-weight: 400;
        display: flex;
        align-items: center;
        /deep/ .iconzhankai,.iconshouqi{
          font-size: 7px;
          vertical-align: middle;
          margin-left: 15px;
        }
        .versionTitle{
          max-width: 500px;
          word-break: break-all;
        }
        .dian{
          display: inline-block;
          width: 8px;
          height: 8px;
          background: #fff;
          border-radius: 50%;
          margin-right: 17px;
        }
      }
      .versionContent{
        padding: 10px 36px 10px 22px;
        margin-left: 3.5px;
        border-left: 1px dotted #fff;
        font-weight: 400;
        font-size: 14px;
        
        .versionContentHtml{
          background: rgba(255,255,255,0.1);
          line-height: 24px;
          padding: 15px 20px;
          max-width: 515px;
          max-height: 60vh;
          overflow: auto;
          border-radius: 4px;
        }
      }
    }
    
  }
}
</style>